import React, { useContext } from 'react';
import AppContext from './context/AppContext';
import '../styles/InfoGrid.css';

const InfoGrid = () => {
    const { appContext } = useContext(AppContext);
    const appConfig = appContext.config.themeConfig;

    return (
        <div
            className={'info-grid--container'}>
            {appConfig.infoCards.map((item, index) => (
                <div
                    key={item.url}
                    className={'d-flex flex-column gap-2 align-items-center justify-content-center text-center'}
                    style={{
                        flexGrow: '1',
                        border: `4px solid ${index % 2 === 0 ? 'rgba(1, 155, 230, 1)' : 'rgba(7, 79, 129, 1)'}`,
                    }}>
                    <img
                        alt={`card ${index}`}
                        src={item.url}
                        style={{
                            width: '100%',
                            height: '100%',
                        }} />
                </div>
            ))}
        </div>
    );
};

export default InfoGrid;